$(document).ready(function() {
  function initGuideTour() {
    let $guided_tour_slider = $(".js-guided-tour-slider");

    if ($guided_tour_slider.length) {
      if (window.matchMedia("(min-width: 680px)").matches) {
        $(".js-guided-tour-close").on("click", function () {
          $("body").removeClass("js-guided-tour-active");
          $(".js-guided-tour").hide();
        });

        $(".js-guided-tour-trigger").on("click", function () {
          $("body").addClass("js-guided-tour-active");
          $(".js-guided-tour").show();

          if (!$guided_tour_slider.hasClass('slick-initialized')) {
            $guided_tour_slider.slick({
              arrows: true,
              dots: true,
              infinite: false,
              prevArrow: $guided_tour_slider
                .siblings(".js-tour-slider-nav")
                .children(".js-tour-slider-prev"),
              nextArrow: $guided_tour_slider
                .siblings(".js-tour-slider-nav")
                .children(".js-tour-slider-next"),
              fade: false,
              initialSlide: 0,
              autoplay: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplaySpeed: 4000,
              rows: 0,
              responsive: [
                {
                  breakpoint: 680,
                  settings: {
                    arrows: false,
                    dots: true
                  }
                }
              ]
            });
          } else {
            $guided_tour_slider.slick('slickGoTo', 0);
            $(".js-guided-tour").css("top", 0 + "px");
          }
        });

        $(".js-guided-tour-close").on("click", function () {
          $("body").removeClass("js-guided-tour-active");
          $(".js-guided-tour").hide();
        });

        $guided_tour_slider.on("afterChange", function (slick, currentSlide) {
          let data_position = $(".slick-current").data("position"),
              section = $("#" + data_position),
              data_trigger = $(".slick-current").data("trigger"),
              wrapper_offset = $(".js-guided-tour-wrapper").offset().top,
              offset = 0;
          if (data_trigger != undefined && data_trigger != null) {
            console.log(data_position);
            $("#" + data_trigger + ":not(.active)").click();
          }

          if (section != undefined && section != null && section.length != 0) {
            let section_offset = $("#" + data_position).offset().top;
            offset = section_offset - wrapper_offset - 40;

            $(".js-guided-tour").addClass("js-has-pointer");
            $('html,body').animate({
              scrollTop: $("#" + data_position).offset().top - ($(window).height() - $(this).outerHeight(true)) / 2
            }, 200);
            $(".js-guided-tour").css("top", offset + "px");
          } else {
            $(".js-guided-tour").removeClass("js-has-pointer");
          }
        });
      } else {
        $(".js-guided-tour-trigger").on("click", function () {
          $("html, body").animate(
            {
              scrollTop: $(".js-guided-tour-modal").offset().top,
            },
            400
          );
        });

        if (!$guided_tour_slider.hasClass('slick-initialized')) {
          $guided_tour_slider.slick({
            arrows: true,
            dots: true,
            infinite: false,
            prevArrow: $guided_tour_slider
              .siblings(".js-tour-slider-nav")
              .children(".js-tour-slider-prev"),
            nextArrow: $guided_tour_slider
              .siblings(".js-tour-slider-nav")
              .children(".js-tour-slider-next"),
            fade: false,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 4000,
            rows: 0,
            responsive: [
              {
                breakpoint: 680,
                settings: {
                  arrows: false,
                  dots: true
                }
              }
            ]
          });
        }
      }
    }
  }

  initGuideTour();

  $(window).on("resize orientationchange", function () {
    initGuideTour();
  });
});
